import { Icon } from "../lib/Icon";

interface Props {
  onFinish: () => void;
}

/** Onboarding mínimo viable: pantalla de bienvenida + CTA al álbum. Los flujos de
 * scan/import/manual se reactivarán cuando haya integración real (visión, OCR). */
export function OnboardingScreen({ onFinish }: Props) {
  return (
    <div className="onb-stage">
      <div className="onb-card">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
          <div style={{ width: 72, height: 72, borderRadius: "50%", background: "var(--primary)", color: "white", display: "grid", placeItems: "center", boxShadow: "var(--shadow-glow)" }}>
            <Icon name="sparkle" size={36} />
          </div>
        </div>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 800, textAlign: "center", margin: "0 0 8px" }}>¡Bienvenido a PaniniNilabs!</h2>
        <p style={{ textAlign: "center", color: "var(--fg-muted)", margin: "0 0 24px" }}>
          Para empezar, marca tus láminas pegadas y repetidas. Tarda menos de un minuto por equipo.
        </p>

        <div className="col" style={{ gap: 10 }}>
          <div style={{ background: "var(--bg-subtle)", padding: 14, borderRadius: 10, display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--primary-soft)", color: "var(--primary)", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <Icon name="check" size={16} />
            </div>
            <div>
              <div style={{ fontWeight: 600 }}>1 click → pegada</div>
              <div className="tiny muted">Marca las que tienes en tu álbum.</div>
            </div>
          </div>
          <div style={{ background: "var(--bg-subtle)", padding: 14, borderRadius: 10, display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "color-mix(in oklab, var(--accent-amber) 22%, transparent)", color: "#b45309", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <Icon name="flame" size={16} />
            </div>
            <div>
              <div style={{ fontWeight: 600 }}>2 clicks → repetida</div>
              <div className="tiny muted">Las que te sobran y puedes intercambiar.</div>
            </div>
          </div>
          <div style={{ background: "var(--bg-subtle)", padding: 14, borderRadius: 10, display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "color-mix(in oklab, var(--accent-magenta) 22%, transparent)", color: "var(--accent-magenta)", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <Icon name="sparkle" size={16} />
            </div>
            <div>
              <div style={{ fontWeight: 600 }}>Match automático</div>
              <div className="tiny muted">Apenas otro coleccionista entre con láminas que necesitas, te avisaremos.</div>
            </div>
          </div>
        </div>

        <button className="btn btn-primary btn-lg" onClick={onFinish} style={{ width: "100%", justifyContent: "center", marginTop: 24 }}>
          Empezar <Icon name="arrow" size={16} />
        </button>
      </div>
    </div>
  );
}
